export const showToast = (message, type = 'info') => ({
    type: 'SET_SUCCESS_MESSAGE',
    payload: { message, type },
});
